export const siteOrigin = 'https://www.radiansoul.com';
export const businessProfileUrl = 'https://share.google/2nOgUJUOzQg1ry7v3';
export const socialImage = `${siteOrigin}/images/radian-soul-social.jpg`;
export const indexRobots = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
export const privateRobots = 'noindex, follow';
export const isProductionHost = (hostname: string) => ['radiansoul.com', 'www.radiansoul.com'].includes(hostname);
